export default __webpack_public_path__ + "static/media/backimage.00caa45e.png";